<template>
  <base-modal modal-content-class="resub">
    <div class="content">
      <form>
        <h1>{{ $_getTranslations.home_modals_resubscribepin_you_are_close }}</h1>

        <img src="/static/images/register/mobile_img.svg" class="modal_simple_img" alt="mobile image"/>

        <p>{{ $_getTranslations.home_modals_resubscribepin_we_sent }}</p>

        <base-digit-form-input
          v-model="formValues.pin"
          :label="$_getTranslations.home_modals_resubscribepin_enter_the"
          :invalid="pinInputValidationConfiguration.invalid"
          :max-length="pinSize"
          input-id="pin_sms"
        ></base-digit-form-input>

        <div v-if="pinInputValidationConfiguration.invalid" class="error_text">
          {{ pinInputValidationConfiguration.message }}
        </div>

        <base-button container-class="resub_btn" @button:click.prevent="handleSubmit">
          {{ $_getTranslations.home_modals_resubscribepin_confirm }}
        </base-button>
      </form>
    </div>
  </base-modal>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex'
import BaseLoaderModal from '../../common/modal/BaseLoaderModal'
import BaseModal from '../../common/modal/BaseModal'
import BaseButton from '../../common/button/BaseButton'
import BaseDigitFormInput from '../../common/formInput/BaseDigitFormInput'
import WelcomeReturningUnsub from './WelcomeReturningUnsub'
import ResubscribeError from './ResubscribeError'
import integrationMixin from '../../../common/mixins/integration'
import translationMixin from '../../../common/mixins/translation'
import modals from '../../../common/modals'
import {apiResponseTypeEnum} from '../../../constants/api'

export default {
  name: 'resubscribe-via-pin',
  components: {
    BaseModal,
    BaseButton,
    BaseDigitFormInput,
    WelcomeReturningUnsub
  },
  mixins: [
    integrationMixin,
    translationMixin
  ],
  data () {
    return {
      formValues: {pin: ''},
      pinInputValidationConfiguration: {invalid: false, message: ''},
      pinSize: 4
    }
  },
  methods: {
    ...mapActions('profile', [
      'sendReOptinPin',
      'getUserLoginDetails'
    ]),
    ...mapMutations('common', [
      'storeModalForSettings',
      'storeModalForStore',
      'storeModalForHomePage'
    ]),
    hasAsync () {
      const activeIntegration = this.getIntegrationByName()
      return activeIntegration && activeIntegration.value.hasAsync
    },
    validateForm () {
      const isPinRequiredRuleFailed = () => {
        if (!this.formValues.pin) {
          return {message: 'common_error_input_field_required'}
        }

        return null
      }

      const isPinContentCriteriaRuleFailed = () => {
        // const validationRegexPin = /^[0-9]{0,8}$/
        //
        // if (!this.formValues.pin.match(validationRegexPin)) {
        //   return {message: 'home_modals_resubscribepin_oops'}
        // }

        return null
      }

      const errorConfiguration = isPinRequiredRuleFailed() || isPinContentCriteriaRuleFailed()

      return {
        invalid: !!errorConfiguration,
        configuration: errorConfiguration
      }
    },
    resetErrors () {
      if (this.pinInputValidationConfiguration.invalid) {
        this.pinInputValidationConfiguration.invalid = false
        this.pinInputValidationConfiguration.message = ''
      }
    },
    handleSubmit () {
      this.resetErrors()

      const {invalid, configuration} = this.validateForm()

      if (invalid) {
        this.pinInputValidationConfiguration.message = this.$_translateText({key: configuration.message})
        this.pinInputValidationConfiguration.invalid = true

        return
      }

      this.sendPin()
    },
    sendPin () {
      const pinParam = {pin: this.formValues.pin}

      this.sendReOptinPin({pinObject: pinParam}).then(() => {
        if (this.twoStepVerificationVerified) {
          if (this.hasAsync()) {
            this.showLoaderModal()

            this.$axios.get(`api/getStatusVerificationPin?msisdn=${this.userDetails.msisdn}`).then(response => {
              const {responseEnum} = response.data

              if (responseEnum === apiResponseTypeEnum.OPERATION_SUCCESS) {
                this.showSuccessModal()
              } else {
                this.showErrorModal()
              }
            })
          } else {
            this.showSuccessModal()
          }
        } else if (this.twoStepVerificationWrongPin) {
          this.pinInputValidationConfiguration.message = this.$_translateText({key: 'home_modals_resubscribepin_oops'})
          this.pinInputValidationConfiguration.invalid = true
        } else if (this.twoStepVerificationServerError) {
          this.pinInputValidationConfiguration.message = this.$_translateText({key: 'common_error_server_unavailable'})
          this.pinInputValidationConfiguration.invalid = true
        }
      })
    },
    showLoaderModal () {
      this.showModalByPage(BaseLoaderModal)
    },
    showSuccessModal () {
      this.getUserLoginDetails().then(() => {
        this.showModalByPage(WelcomeReturningUnsub)
      })
    },
    showErrorModal () {
      this.showModalByPage(ResubscribeError)
    },
    showModalByPage (modal) {
      if (sessionStorage.getItem('toPage') === '/home' || sessionStorage.getItem('toPage') === '/home/profile') {
        this.storeModalForHomePage(modal)
        modals.showHideModalForHomeStorePage(this)
      } else if (sessionStorage.getItem('toPage') === '/home/store') {
        this.storeModalForStore(modal)
        modals.setupCommonModal({
          afterHideCallback: () => {
            this.storeModalForStore(null)
          }
        })
      } else {
        this.storeModalForSettings(modal)
        modals.showHideModalForHomePage(this)
      }
    }
  },
  computed: {
    ...mapState('profile', [
      'twoStepVerificationVerified',
      'twoStepVerificationWrongPin',
      'twoStepVerificationServerError'
    ]),
    ...mapState('common', [
      'multiOperatorInfo',
      'userDetails'
    ])
  }
}
</script>




// WEBPACK FOOTER //
// src/components/home/modals/ResubscribeViaPin.vue